"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetFocus = void 0;
var _react = require("react");
var useSetFocus = function useSetFocus() {
  var htmlElRef = (0, _react.useRef)(null);
  var setFocus = (0, _react.useCallback)(function () {
    htmlElRef.current && htmlElRef.current.focus();
  }, [htmlElRef]);
  return [htmlElRef, setFocus];
};
exports.useSetFocus = useSetFocus;